import { getOrgsDetails, probDocsCheck, getOrgCDocs } from "../../../services/httpCalls"

export const showDocsAlreadyUploaded = async ({
    setShowLoader,
    setSelectionValue,
    setCompanyType,
    selectionValue,
    setUploadedFileList,
    setAlreadyuploaded,
    setUploadedFileLinks,
    companyType
}) => {

    let CompanyPan = []
    let CompanyGst = []
    let CompanyCOI = []
    let CompanyMoa = []
    let CompanyAoa = []
    let CompanyPartnershipDeed = []
    let CompanyLLPDeed = []
    let CompanyBoardResolution = []
    let CompanyAccountStatement = []
    let CompanyBalanceSheet = []
    let CompanyUtilityBill = []
    let CompanyIEC = []
    let CompanyITR = []
    let CompanyShopEstablishment = []
    let CompanyAddressProof = []
    let CompanySalesAndIncomeTaxReturns = []
    let CompanyUdyamRegistrationCertificate = []
    let CompanyVatOr81CstOrGstCertificate = []
    let CompanyDocumentIssuedByTaxAuthorities = []
    let CompanyCompleteIncomeTaxReturn = []
    let CompanyAnnualDeclaration = []
    let CompanySoleProrietorAadharCard = []


    setShowLoader(true)

    let orgId = localStorage.getItem("orgId")
    let docsList = {
        COMPANY_PAN_CARD: false,
        CERTIFICATE_OF_INCORPORATION: false,
        GST_CERTIFICATE: false,
        MOA: false,
        AOA: false,
        PARTNERSHIP_DEED: false,
        LLP_DEED: false,
        BOARD_RESOLUTION: false,
        ACCOUNT_STATEMENT: false,
        BALANCE_SHEET: false,
        UTILITY_BILL: false,
        IEC: false,
        ITR: false,
        SHOP_ESTABLISHMENT: false,
        ADDRESS_PROOF: false,
        SALES_AND_INCOME_TAX_RETURNS: false,
        UDYAM_REGISTRATION_CERTIFICATE: false,
        VAT_OR_81CST_OR_GST_CERTIFICATE: false,
        DOCUMENT_ISSUED_BY_TAX_AUTHORITIES: false,
        COMPLETE_INCOME_TAX_RETURN: false,
        ANNUAL_DECLARATION: false,
        SOLE_PROPRIETER_AADHAR_CARD: false
    }
    let uploadedFiles_ = {
        COMPANY_PAN_CARD: "",
        GST_CERTIFICATE: "",
        CERTIFICATE_OF_INCORPORATION: "",
        MOA: "",
        AOA: "",
        PARTNERSHIP_DEED: "",
        LLP_DEED: "",
        BOARD_RESOLUTION: "",
        ACCOUNT_STATEMENT: "",
        BALANCE_SHEET: "",
        UTILITY_BILL: "",
        IEC: "",
        ITR: "",
        SHOP_ESTABLISHMENT: "",
        ADDRESS_PROOF: "",
        SALES_AND_INCOME_TAX_RETURNS: "",
        UDYAM_REGISTRATION_CERTIFICATE: "",
        VAT_OR_81CST_OR_GST_CERTIFICATE: "",
        DOCUMENT_ISSUED_BY_TAX_AUTHORITIES: "",
        COMPLETE_INCOME_TAX_RETURN: "",
        ANNUAL_DECLARATION: "",
        SOLE_PROPRIETER_AADHAR_CARD:""
    }
    let uploadedFilesLinks_ = {
        COMPANY_PAN_CARD: "",
        GST_CERTIFICATE: "",
        CERTIFICATE_OF_INCORPORATION: "",
        MOA: "",
        AOA: "",
        PARTNERSHIP_DEED: "",
        LLP_DEED: "",
        BOARD_RESOLUTION: "",
        ACCOUNT_STATEMENT: "",
        BALANCE_SHEET: "",
        UTILITY_BILL: "",
        IEC: "",
        ITR: "",
        SHOP_ESTABLISHMENT: "",
        ADDRESS_PROOF: "",
        SALES_AND_INCOME_TAX_RETURNS: "",
        UDYAM_REGISTRATION_CERTIFICATE: "",
        VAT_OR_81CST_OR_GST_CERTIFICATE: "",
        DOCUMENT_ISSUED_BY_TAX_AUTHORITIES: "",
        COMPLETE_INCOME_TAX_RETURN: "",
        ANNUAL_DECLARATION: "",
        SOLE_PROPRIETER_AADHAR_CARD:""
    }
    try {
        await getOrgsDetails(orgId).then(res => {
            let orgsDetail = res
            if (orgsDetail) {
                if (res?.isOptInward && res?.isOptOutward) {
                    setSelectionValue("both")
                } else if (res?.isOptInward && !res?.isOptOutward) {
                    setSelectionValue("inward")
                } else {
                    setSelectionValue("outward")
                }
                // orgsDetail = JSON.parse(orgsDetail)
                setCompanyType(orgsDetail?.companyType)
            }
        })
        await probDocsCheck(orgId)
        await getOrgCDocs(orgId)
            .then(res => {
                if (res.length) {
                    res?.map(val => {
                       
                        if (val.type === "COMPANY_PAN_CARD") {
                            docsList["COMPANY_PAN_CARD"] = true
                            // uploadedFiles_['COMPANY_PAN_CARD'] = val?.name?.split(`~~`)[1]
                            CompanyPan.push(val)
                        }
                        if (val.type === "CERTIFICATE_OF_INCORPORATION") {
                            docsList["CERTIFICATE_OF_INCORPORATION"] = true
                            uploadedFiles_['CERTIFICATE_OF_INCORPORATION'] = val?.name?.split(`~~`)[1]
                            CompanyCOI.push(val)
                        }
                        if (val.type === "GST_CERTIFICATE") {
                            docsList["GST_CERTIFICATE"] = true
                            // uploadedFiles_['GST_CERTIFICATE'] = val?.name?.split(`~~`)[1]
                            CompanyGst.push(val)
                        }
                        if (val.type === "MOA") {
                            docsList["MOA"] = true
                            uploadedFiles_['MOA'] = val?.name?.split(`~~`)[1]
                            CompanyMoa.push(val)
                        }
                        if (val.type === "AOA") {
                            docsList["AOA"] = true
                            uploadedFiles_['AOA'] = val?.name?.split(`~~`)[1]
                            CompanyAoa.push(val)
                        }
                        if (val.type === "PARTNERSHIP_DEED") {
                            docsList["PARTNERSHIP_DEED"] = true
                            uploadedFiles_['AOA'] = val?.name?.split(`~~`)[1]
                            CompanyPartnershipDeed.push(val)
                        }
                        if (val.type === "LLP_DEED") {
                            docsList["LLP_DEED"] = true
                            // uploadedFiles_['AOA'] = val?.name?.split(`~~`)[1]
                            CompanyLLPDeed.push(val)
                        }
                        if (val.type === "BOARD_RESOLUTION") {
                            docsList["BOARD_RESOLUTION"] = true
                            uploadedFiles_['BOARD_RESOLUTION'] = val?.name?.split(`~~`)[1]
                            CompanyBoardResolution.push(val)
                        }
                        if (val.type === "ACCOUNT_STATEMENT") {
                            docsList["ACCOUNT_STATEMENT"] = true
                            uploadedFiles_['ACCOUNT_STATEMENT'] = val?.name?.split(`~~`)[1]
                            CompanyAccountStatement.push(val)
                        }
                        if (val.type === "BALANCE_SHEET") {
                            docsList["BALANCE_SHEET"] = true
                            CompanyBalanceSheet.push(val)
                        }
                        if (val.type === "UTILITY_BILL") {                            
                            docsList["UTILITY_BILL"] = true
                            CompanyUtilityBill.push(val)
                        }
                        if (val.type === "IEC") {
                            docsList["IEC"] = true
                            CompanyIEC.push(val)
                        }
                        if (val.type === "ITR") {
                            docsList["ITR"] = true
                            CompanyITR.push(val)
                        }
                        if (val.type === "SHOP_ESTABLISHMENT") {
                            docsList["SHOP_ESTABLISHMENT"] = true
                            CompanyShopEstablishment.push(val)
                        }
                        if (val.type === "ADDRESS_PROOF") {
                            docsList["ADDRESS_PROOF"] = true
                            CompanyAddressProof.push(val)
                        }
                        if (val.type === "SALES_AND_INCOME_TAX_RETURNS") {
                            docsList["SALES_AND_INCOME_TAX_RETURNS"] = true
                            CompanySalesAndIncomeTaxReturns.push(val)
                        }
                        if (val.type === "UDYAM_REGISTRATION_CERTIFICATE") {
                            docsList["UDYAM_REGISTRATION_CERTIFICATE"] = true
                            CompanyUdyamRegistrationCertificate.push(val)
                        }
                        if (val.type === "VAT_OR_81CST_OR_GST_CERTIFICATE") {
                            docsList["VAT_OR_81CST_OR_GST_CERTIFICATE"] = true
                            CompanyVatOr81CstOrGstCertificate.push(val)
                        }
                        if (val.type === "DOCUMENT_ISSUED_BY_TAX_AUTHORITIES") {
                            docsList["DOCUMENT_ISSUED_BY_TAX_AUTHORITIES"] = true
                            CompanyDocumentIssuedByTaxAuthorities.push(val)
                        }
                        if (val.type === "COMPLETE_INCOME_TAX_RETURN") {
                            docsList["COMPLETE_INCOME_TAX_RETURN"] = true
                            CompanyCompleteIncomeTaxReturn.push(val)
                        }
                        if (val.type === "ANNUAL_DECLARATION") {
                            docsList["ANNUAL_DECLARATION"] = true
                            CompanyAnnualDeclaration.push(val)
                        }
                        if (val.type === "SOLE_PROPRIETER_AADHAR_CARD") {
                            docsList["SOLE_PROPRIETER_AADHAR_CARD"] = true
                            CompanySoleProrietorAadharCard.push(val)
                        }
                    })
                    let latestCompanyPanObject = CompanyPan?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyCOIObject = CompanyCOI?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyGstObject = CompanyGst?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyMOAObject = CompanyMoa?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyAOAObject = CompanyAoa?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyPartnershipDeedObject = CompanyPartnershipDeed?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyLLPDeedObject = CompanyLLPDeed?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyBoardResolutionObject = CompanyBoardResolution?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyAccountStatementObject = CompanyAccountStatement?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyBalanceSheetObject = CompanyBalanceSheet?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyUtilityBillObject = CompanyUtilityBill?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyIECObject = CompanyIEC?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyITRObject = CompanyITR?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyShopEstablishmentObject = CompanyShopEstablishment?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyAddressProofObject = CompanyAddressProof?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanySalesAndIncomeTaxReturnsObject = CompanySalesAndIncomeTaxReturns?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyUdyamRegistrationCertificateObject = CompanyUdyamRegistrationCertificate?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyVatOr81CstOrGstCertificateObject = CompanyVatOr81CstOrGstCertificate?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyDocumentIssuedByTaxAuthoritiesObject = CompanyDocumentIssuedByTaxAuthorities?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyCompleteIncomeTaxReturnObject = CompanyCompleteIncomeTaxReturn?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestCompanyCompleteAnnualDeclarationObject = CompanyAnnualDeclaration?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let LatestCompanySoleProrietorAadharCard = CompanySoleProrietorAadharCard?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    if (selectionValue === "inward") {
                        // if (Object.keys(latestCompanyGstObject).length && Object.keys(latestCompanyPanObject).length) {
                        uploadedFiles_[
                            "COMPANY_PAN_CARD"
                        ] = latestCompanyPanObject?.name?.split(`~~`)[1]
                                ? latestCompanyPanObject?.name?.split(`~~`)[1]
                                : ""
                        uploadedFiles_[
                            "GST_CERTIFICATE"
                        ] = latestCompanyGstObject?.name?.split(`~~`)[1]
                                ? latestCompanyGstObject?.name?.split(`~~`)[1]
                                : ""
                        uploadedFiles_[
                            "PARTNERSHIP_DEED"
                        ] = latestCompanyPartnershipDeedObject?.name?.split(`~~`)[1]
                                ? latestCompanyPartnershipDeedObject?.name?.split(`~~`)[1]
                                : ""
                        uploadedFiles_[
                            "LLP_DEED"
                        ] = latestCompanyLLPDeedObject?.name?.split(`~~`)[1]
                                ? latestCompanyLLPDeedObject?.name?.split(`~~`)[1]
                                : ""
                                uploadedFiles_[
                                    "CERTIFICATE_OF_INCORPORATION"
                                ] = latestCompanyCOIObject?.name?.split(`~~`)[1]
                                        ? latestCompanyCOIObject?.name?.split(`~~`)[1]
                                        : ""
                                uploadedFiles_["MOA"] = latestCompanyMOAObject?.name?.split(
                                    `~~`
                                )[1]
                                    ? latestCompanyMOAObject?.name?.split(`~~`)[1]
                                    : ""
                                uploadedFiles_["AOA"] = latestCompanyAOAObject?.name?.split(
                                    `~~`
                                )[1]
                                    ? latestCompanyAOAObject?.name?.split(`~~`)[1]
                                    : ""
                                    uploadedFiles_[
                                        "BOARD_RESOLUTION"
                                    ] = latestCompanyBoardResolutionObject?.name?.split(`~~`)[1]
                                        ? latestCompanyBoardResolutionObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "ACCOUNT_STATEMENT"
                                    ] = latestCompanyAccountStatementObject?.name?.split(`~~`)[1]
                                        ? latestCompanyAccountStatementObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "BALANCE_SHEET"
                                    ] = latestCompanyBalanceSheetObject?.name?.split(`~~`)[1]
                                        ? latestCompanyBalanceSheetObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "UTILITY_BILL"
                                    ] = latestCompanyUtilityBillObject?.name?.split(`~~`)[1]
                                        ? latestCompanyUtilityBillObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "IEC"
                                    ] = latestCompanyIECObject?.name?.split(`~~`)[1]
                                        ? latestCompanyIECObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "ITR"
                                    ] = latestCompanyITRObject?.name?.split(`~~`)[1]
                                        ? latestCompanyITRObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "SHOP_ESTABLISHMENT"
                                    ] = latestCompanyShopEstablishmentObject?.name?.split(`~~`)[1]
                                        ? latestCompanyShopEstablishmentObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "ADDRESS_PROOF"
                                    ] = latestCompanyAddressProofObject?.name?.split(`~~`)[1]
                                        ? latestCompanyAddressProofObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "SALES_AND_INCOME_TAX_RETURNS"
                                    ] = latestCompanySalesAndIncomeTaxReturnsObject?.name?.split(`~~`)[1]
                                        ? latestCompanySalesAndIncomeTaxReturnsObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "UDYAM_REGISTRATION_CERTIFICATE"
                                    ] = latestCompanyUdyamRegistrationCertificateObject?.name?.split(`~~`)[1]
                                        ? latestCompanyUdyamRegistrationCertificateObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "VAT_OR_81CST_OR_GST_CERTIFICATE"
                                    ] = latestCompanyVatOr81CstOrGstCertificateObject?.name?.split(`~~`)[1]
                                        ? latestCompanyVatOr81CstOrGstCertificateObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "DOCUMENT_ISSUED_BY_TAX_AUTHORITIES"
                                    ] = latestCompanyDocumentIssuedByTaxAuthoritiesObject?.name?.split(`~~`)[1]
                                        ? latestCompanyDocumentIssuedByTaxAuthoritiesObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "COMPLETE_INCOME_TAX_RETURN"
                                    ] = latestCompanyCompleteIncomeTaxReturnObject?.name?.split(`~~`)[1]
                                        ? latestCompanyCompleteIncomeTaxReturnObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "ANNUAL_DECLARATION"
                                    ] = latestCompanyCompleteAnnualDeclarationObject?.name?.split(`~~`)[1]
                                        ? latestCompanyCompleteAnnualDeclarationObject?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "SOLE_PROPRIETER_AADHAR_CARD"
                                    ] = LatestCompanySoleProrietorAadharCard?.name?.split(`~~`)[1]
                                        ? LatestCompanySoleProrietorAadharCard?.name?.split(`~~`)[1]
                                        : "";
                                    
                                    uploadedFiles_[
                                        "LLP_DEED"
                                    ] = latestCompanyLLPDeedObject?.name?.split(`~~`)[1]
                                        ? latestCompanyLLPDeedObject?.name?.split(`~~`)[1]
                                        : "";
                        uploadedFilesLinks_[
                            "COMPANY_PAN_CARD"
                        ] = latestCompanyPanObject?.s3Url?.split("amazonaws.com/")[1]
                                ? latestCompanyPanObject?.s3Url?.split("amazonaws.com/")[1]
                                : ""
                        uploadedFilesLinks_[
                            "GST_CERTIFICATE"
                        ] = latestCompanyGstObject?.s3Url?.split("amazonaws.com/")[1]
                                ? latestCompanyGstObject?.s3Url?.split("amazonaws.com/")[1]
                                : ""
                        uploadedFilesLinks_[
                            "PARTNERSHIP_DEED"
                        ] = latestCompanyPartnershipDeedObject?.s3Url?.split("amazonaws.com/")[1]
                                ? latestCompanyPartnershipDeedObject?.s3Url?.split("amazonaws.com/")[1]
                                : ""
                        uploadedFilesLinks_[
                            "LLP_DEED"
                        ] = latestCompanyLLPDeedObject?.s3Url?.split("amazonaws.com/")[1]
                                ? latestCompanyLLPDeedObject?.s3Url?.split("amazonaws.com/")[1]
                                : ""
                        uploadedFilesLinks_[
                            "BOARD_RESOLUTION"
                        ] = latestCompanyBoardResolutionObject?.s3Url?.split("amazonaws.com/")[1]
                                ? latestCompanyBoardResolutionObject?.s3Url?.split("amazonaws.com/")[1]
                                : ""
                                uploadedFilesLinks_[
                                    "ACCOUNT_STATEMENT"
                                ] = latestCompanyAccountStatementObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyAccountStatementObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                uploadedFilesLinks_[
                                    "BALANCE_SHEET"
                                ] = latestCompanyBalanceSheetObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyBalanceSheetObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                uploadedFilesLinks_[
                                    "UTILITY_BILL"
                                ] = latestCompanyUtilityBillObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyUtilityBillObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                        uploadedFiles_[
                                            "UTILITY_BILL"
                                        ] = latestCompanyUtilityBillObject?.name?.split(`~~`)[1]
                                                ? latestCompanyUtilityBillObject?.name?.split(`~~`)[1]
                                                : ""
                                uploadedFilesLinks_[
                                    "IEC"
                                ] = latestCompanyIECObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyIECObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                        uploadedFiles_[
                                            "IEC"
                                        ] = latestCompanyIECObject?.name?.split(`~~`)[1]
                                                ? latestCompanyIECObject?.name?.split(`~~`)[1]
                                                : ""
                                uploadedFilesLinks_[
                                    "ITR"
                                ] = latestCompanyITRObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyITRObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                        uploadedFiles_[
                                            "ITR"
                                        ] = latestCompanyITRObject?.name?.split(`~~`)[1]
                                                ? latestCompanyITRObject?.name?.split(`~~`)[1]
                                                : ""
                                uploadedFilesLinks_[
                                    "SHOP_ESTABLISHMENT"
                                ] = latestCompanyShopEstablishmentObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyShopEstablishmentObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                        uploadedFiles_[
                                            "SHOP_ESTABLISHMENT"
                                        ] = latestCompanyShopEstablishmentObject?.name?.split(`~~`)[1]
                                                ? latestCompanyShopEstablishmentObject?.name?.split(`~~`)[1]
                                                : ""
                                uploadedFilesLinks_[
                                    "ADDRESS_PROOF"
                                ] = latestCompanyAddressProofObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyAddressProofObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                uploadedFilesLinks_[
                                    "SALES_AND_INCOME_TAX_RETURNS"
                                ] = latestCompanySalesAndIncomeTaxReturnsObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanySalesAndIncomeTaxReturnsObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                uploadedFilesLinks_[
                                    "UDYAM_REGISTRATION_CERTIFICATE"
                                ] = latestCompanyUdyamRegistrationCertificateObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyUdyamRegistrationCertificateObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                uploadedFilesLinks_[
                                    "VAT_OR_81CST_OR_GST_CERTIFICATE"
                                ] = latestCompanyVatOr81CstOrGstCertificateObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyVatOr81CstOrGstCertificateObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                uploadedFilesLinks_[
                                    "DOCUMENT_ISSUED_BY_TAX_AUTHORITIES"
                                ] = latestCompanyDocumentIssuedByTaxAuthoritiesObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyDocumentIssuedByTaxAuthoritiesObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                uploadedFilesLinks_[
                                    "COMPLETE_INCOME_TAX_RETURN"
                                ] = latestCompanyCompleteIncomeTaxReturnObject?.s3Url?.split("amazonaws.com/")[1]
                                        ? latestCompanyCompleteIncomeTaxReturnObject?.s3Url?.split("amazonaws.com/")[1]
                                        : ""
                                        uploadedFilesLinks_[
                                            "ANNUAL_DECLARATION"
                                        ] = latestCompanyCompleteAnnualDeclarationObject?.s3Url?.split("amazonaws.com/")[1]
                                                ? latestCompanyCompleteAnnualDeclarationObject?.s3Url?.split("amazonaws.com/")[1]
                                                : ""
                                uploadedFilesLinks_[
                                    "SOLE_PROPRIETER_AADHAR_CARD"
                                    ] = LatestCompanySoleProrietorAadharCard?.s3Url?.split("amazonaws.com/")[1]
                                        ? LatestCompanySoleProrietorAadharCard?.s3Url?.split("amazonaws.com/")[1]
                                        : ""

                                        uploadedFilesLinks_[
                                            "CERTIFICATE_OF_INCORPORATION"
                                        ] = latestCompanyCOIObject?.s3Url?.split("amazonaws.com/")[1]
                                                ? latestCompanyCOIObject?.s3Url?.split("amazonaws.com/")[1]
                                                : ""
                                        uploadedFilesLinks_["MOA"] = latestCompanyMOAObject?.s3Url?.split(
                                            "amazonaws.com/"
                                        )[1]
                                            ? latestCompanyMOAObject?.s3Url?.split("amazonaws.com/")[1]
                                            : ""
                                        uploadedFilesLinks_["AOA"] = latestCompanyAOAObject?.s3Url?.split(
                                            "amazonaws.com/"
                                        )[1]
                                            ? latestCompanyAOAObject?.s3Url?.split("amazonaws.com/")[1]
                                            : ""
                                           
                        // }
                    } else {
                        // if (Object.keys(latestCompanyAOAObject).length && Object.keys(latestCompanyMOAObject).length && Object.keys(latestCompanyGstObject).length && Object.keys(latestCompanyCOIObject).length && Object.keys(latestCompanyPanObject).length) {
                        uploadedFiles_[
                            "COMPANY_PAN_CARD"
                        ] = latestCompanyPanObject?.name?.split(`~~`)[1]
                                ? latestCompanyPanObject?.name?.split(`~~`)[1]
                                : ""
                        uploadedFiles_[
                            "GST_CERTIFICATE"
                        ] = latestCompanyGstObject?.name?.split(`~~`)[1]
                                ? latestCompanyGstObject?.name?.split(`~~`)[1]
                                : ""
                        uploadedFiles_[
                            "CERTIFICATE_OF_INCORPORATION"
                        ] = latestCompanyCOIObject?.name?.split(`~~`)[1]
                                ? latestCompanyCOIObject?.name?.split(`~~`)[1]
                                : ""
                        uploadedFiles_["MOA"] = latestCompanyMOAObject?.name?.split(
                            `~~`
                        )[1]
                            ? latestCompanyMOAObject?.name?.split(`~~`)[1]
                            : ""
                        uploadedFiles_["AOA"] = latestCompanyAOAObject?.name?.split(
                            `~~`
                        )[1]
                            ? latestCompanyAOAObject?.name?.split(`~~`)[1]
                            : ""
                        uploadedFiles_[
                            "LLP_DEED"
                        ] = latestCompanyLLPDeedObject?.name?.split(`~~`)[1]
                                ? latestCompanyLLPDeedObject?.name?.split(`~~`)[1]
                                : ""
                        uploadedFilesLinks_[
                            "COMPANY_PAN_CARD"
                        ] = latestCompanyPanObject?.s3Url?.split("amazonaws.com/")[1]
                                ? latestCompanyPanObject?.s3Url?.split("amazonaws.com/")[1]
                                : ""
                        uploadedFilesLinks_[
                            "GST_CERTIFICATE"
                        ] = latestCompanyGstObject?.s3Url?.split("amazonaws.com/")[1]
                                ? latestCompanyGstObject?.s3Url?.split("amazonaws.com/")[1]
                                : ""
                        uploadedFilesLinks_[
                            "CERTIFICATE_OF_INCORPORATION"
                        ] = latestCompanyCOIObject?.s3Url?.split("amazonaws.com/")[1]
                                ? latestCompanyCOIObject?.s3Url?.split("amazonaws.com/")[1]
                                : ""
                        uploadedFilesLinks_["MOA"] = latestCompanyMOAObject?.s3Url?.split(
                            "amazonaws.com/"
                        )[1]
                            ? latestCompanyMOAObject?.s3Url?.split("amazonaws.com/")[1]
                            : ""
                        uploadedFilesLinks_["AOA"] = latestCompanyAOAObject?.s3Url?.split(
                            "amazonaws.com/"
                        )[1]
                            ? latestCompanyAOAObject?.s3Url?.split("amazonaws.com/")[1]
                            : ""
                            uploadedFilesLinks_[
                                "UTILITY_BILL"
                            ] = latestCompanyUtilityBillObject?.s3Url?.split("amazonaws.com/")[1]
                                    ? latestCompanyUtilityBillObject?.s3Url?.split("amazonaws.com/")[1]
                                    : ""
                                    uploadedFiles_[
                                        "UTILITY_BILL"
                                    ] = latestCompanyUtilityBillObject?.name?.split(`~~`)[1]
                                            ? latestCompanyUtilityBillObject?.name?.split(`~~`)[1]
                                            : ""
                            uploadedFilesLinks_[
                                "IEC"
                            ] = latestCompanyIECObject?.s3Url?.split("amazonaws.com/")[1]
                                    ? latestCompanyIECObject?.s3Url?.split("amazonaws.com/")[1]
                                    : ""
                                    uploadedFiles_[
                                        "IEC"
                                    ] = latestCompanyIECObject?.name?.split(`~~`)[1]
                                            ? latestCompanyIECObject?.name?.split(`~~`)[1]
                                            : ""
                            uploadedFilesLinks_[
                                "ITR"
                            ] = latestCompanyITRObject?.s3Url?.split("amazonaws.com/")[1]
                                    ? latestCompanyITRObject?.s3Url?.split("amazonaws.com/")[1]
                                    : ""
                                    uploadedFiles_[
                                        "ITR"
                                    ] = latestCompanyITRObject?.name?.split(`~~`)[1]
                                            ? latestCompanyITRObject?.name?.split(`~~`)[1]
                                            : ""
                            uploadedFilesLinks_[
                                "SHOP_ESTABLISHMENT"
                            ] = latestCompanyShopEstablishmentObject?.s3Url?.split("amazonaws.com/")[1]
                                    ? latestCompanyShopEstablishmentObject?.s3Url?.split("amazonaws.com/")[1]
                                    : ""
                                    uploadedFiles_[
                                        "SHOP_ESTABLISHMENT"
                                    ] = latestCompanyShopEstablishmentObject?.name?.split(`~~`)[1]
                                            ? latestCompanyShopEstablishmentObject?.name?.split(`~~`)[1]
                                            : ""
                            uploadedFilesLinks_[
                                "ANNUAL_DECLARATION"
                            ] = latestCompanyCompleteAnnualDeclarationObject?.s3Url?.split("amazonaws.com/")[1]
                                    ? latestCompanyCompleteAnnualDeclarationObject?.s3Url?.split("amazonaws.com/")[1]
                                    : ""
                                    uploadedFiles_[
                                        "ANNUAL_DECLARATION"
                                    ] = latestCompanyCompleteAnnualDeclarationObject?.name?.split(`~~`)[1]
                                        ? latestCompanyCompleteAnnualDeclarationObject?.name?.split(`~~`)[1]
                                        : "";
                                    

                        // }
                    }
                    setUploadedFileList(uploadedFiles_)
                    if (companyType === "LLP") {
                        docsList.AOA = true
                        docsList.MOA = true
                    }
                    setAlreadyuploaded(docsList)
                    setUploadedFileLinks(uploadedFilesLinks_)
                }
            })
            .catch(err => console.log(err))
            .finally(() => setShowLoader(false))
    } catch {
        console.log("err")
    }
}